import React from 'react';

interface ShopIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

const ShopIcon: React.FC<ShopIconProps> = ({
  width = 24,
  height = 24,
  color = '#313485',
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_214_283)">
        <path
          d="M21.1519 16.8213L15 22.5L8.84812 16.8213C5.42125 19.0132 3.125 22.9682 3.125 27.5H26.875C26.875 22.9682 24.5787 19.0132 21.1519 16.8213Z"
          fill={color}
        />
        <path
          d="M15 17.5C17.2188 17.5 19.2056 16.5312 20.5787 15C21.7694 13.6725 22.5 11.9237 22.5 10C22.5 5.85813 19.1419 2.5 15 2.5C10.8581 2.5 7.5 5.85813 7.5 10C7.5 11.9237 8.23063 13.6725 9.42125 15C10.7944 16.5312 12.7812 17.5 15 17.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_214_283">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ShopIcon;
